import React, { useEffect, useState } from "react";
import { Form, Offcanvas, Button } from "react-bootstrap";
import Swal from "sweetalert2";
import { blogSubCategoryServices } from "../../../../APIServices/SitePilotManagement/BlogManagement/blogSubCategoryServices";

const UpdateSubCategory = ({
  show,
  hide,
  title,
  blogSubCategoryData,
  getBlogSubCategoryList,
  setBlogSubCategoryData,
  setBlogSubCategoryIds
}) => {
  const [name, setName] = useState("");
  const [loader, setLoader] = useState(false);

  const updatedBlogSubCategory = async () => {
    Swal.fire({
      title: "Are you sure?",
      text: "Do you want to update this Blog Sub Category?",
      icon: "warning",
      showCancelButton: true,
      cancelButtonColor: "#d33",
      confirmButtonText: "Yes, update it!",
    }).then(async (result) => {
      if (result.isConfirmed) {
        setLoader(true)
        let userData = {}
        userData.subCategoryId = blogSubCategoryData?.subCategoryId
        userData.name = name
        let data = await blogSubCategoryServices.updatedBlogSubCategory(userData)
        if (data?.statusCode === 200) {
          clearData();
          getBlogSubCategoryList()
          setBlogSubCategoryIds([])
          setBlogSubCategoryData("")
        }
        setLoader(false)
      }
    });
  };

  const clearData = () => {
    setName("");
    setLoader(false)
    hide();
  }

  useEffect(() => {
    if (show && blogSubCategoryData) {
      setName(blogSubCategoryData?.name);
      setLoader(false)
    }
  }, [show, blogSubCategoryData]);

  return (
    <Offcanvas show={show} onHide={hide} placement="end">
      <Offcanvas.Header closeButton>
        <Offcanvas.Title>{title}</Offcanvas.Title>
      </Offcanvas.Header>

      <Offcanvas.Body>
        <Form>
          <Form.Group className="mb-2">
            <Form.Label>
              Name <span className="text-danger">*</span>
            </Form.Label>
            <Form.Control
              name="userName"
              value={name}
              onChange={(e) => setName(e.target.value)}
              placeholder="Enter Name"
            />
          </Form.Group>
          <div className="d-flex justify-content-end gap-2 mt-3">
            <Button style={{ fontSize: 12 }} variant="light" onClick={clearData}>
              Cancel
            </Button>
            <Button
              onClick={updatedBlogSubCategory}
              disabled={!name || loader}
              style={{ fontSize: 12 }}>
              {title}
            </Button>
          </div>
        </Form>
      </Offcanvas.Body>
    </Offcanvas>
  );
};

export default UpdateSubCategory;
